import { createSlice } from "@reduxjs/toolkit";
import { setProfileMapData, setProfileRedirectionId, setTabDetails, setTradeLaneCachingHandler, setTradeLaneCategory } from "./tradeLanesProfile.action";
import { profileCategory, tradeLaneTabs } from "@containers/TradeLanesProfile/utils/enum";

let tradeLaneCaching = {
  overview: {
    trade_country: null,
    trade_lane: null,
    trade_port: null,
    location: null,
  },
  trading_partner: null,
  hs_code: null,
  shipmentDistribution: null,
  profileDetails: {},
};

const tradeLanesProfileSlice = createSlice({
  name: "tradeLanesProfile",
  initialState: {
    countDetails: {
      loading: true,
    },
    tradeLaneCategory: null,
    tabDetails: {
      activePanelId: "",
      activeTabId: tradeLaneTabs[0].id,
      mapType: profileCategory,
    },
    tradeLaneCaching: { ...tradeLaneCaching },
    profileRedirectionId: "",
  },
  reducers: {
    profileMapDataHandler: setProfileMapData,
    tradeLaneCategoryHandler: setTradeLaneCategory,
    tabDetailsHandler: setTabDetails,
    profileRedirectionIdHandler: setProfileRedirectionId,
    tradeLaneCachingHandler: setTradeLaneCachingHandler,
  },
});

export const { profileMapDataHandler, tradeLaneCategoryHandler, tabDetailsHandler, profileRedirectionIdHandler, tradeLaneCachingHandler } = tradeLanesProfileSlice.actions;

export default tradeLanesProfileSlice.reducer;
